import { Theme } from '@/common/enums';

export const SYNC_EVENTS = {
  SIDEBAR_STATE: 'sidebar-state',
  SIDEBAR_MOBILE_STATE: 'sidebar-mobile-state',
  THEME: 'theme',
  LOCALE: 'locale',
  COMPOSER_TEXT: 'composer-text',
  THREAD_SWITCH: 'thread-switch',
  RUNTIME_ERROR: 'runtime-error',
  RUNTIME_FINISH: 'runtime-finish',
  THREAD_ARCHIVE: 'thread-archive',
  THREAD_UNARCHIVE: 'thread-unarchive',
  RESUMABLE_STREAM_STARTED: 'resumable-stream-started',
  RESUMABLE_STREAM_STOPPED: 'resumable-stream-stopped',
} as const;

export type SyncEventType = (typeof SYNC_EVENTS)[keyof typeof SYNC_EVENTS];

export type SyncEventPayload = {
  [SYNC_EVENTS.SIDEBAR_STATE]: boolean;
  [SYNC_EVENTS.SIDEBAR_MOBILE_STATE]: boolean;
  [SYNC_EVENTS.THEME]: Theme;
  [SYNC_EVENTS.LOCALE]: string;
  [SYNC_EVENTS.COMPOSER_TEXT]: { threadId: string; text: string };
  [SYNC_EVENTS.THREAD_SWITCH]: string | null;
  [SYNC_EVENTS.RUNTIME_ERROR]: { error: unknown };
  [SYNC_EVENTS.RUNTIME_FINISH]: { threadId?: string | null } | null;
  [SYNC_EVENTS.THREAD_ARCHIVE]: string;
  [SYNC_EVENTS.THREAD_UNARCHIVE]: string;
  [SYNC_EVENTS.RESUMABLE_STREAM_STARTED]: { threadUuid: string; streamId: string };
  // User hit stop in one tab — sibling tabs tailing the same thread cancel their resumed run too.
  [SYNC_EVENTS.RESUMABLE_STREAM_STOPPED]: { threadUuid: string };
};

export type SyncEvent<T extends SyncEventType = SyncEventType> = {
  type: T;
  payload: SyncEventPayload[T];
  timestamp: number;
  tabId: string;
};
